import React from "react";
import { twJoin } from "tailwind-merge";

import { useIsExpandedRow } from "../hooks/useIsExpandedRow";
import { SupChevronRight } from "../../../../icons";

export function GroupIconCell({ id, disabled }: { id: string; disabled: boolean }) {
  const isExpanded = useIsExpandedRow(id);

  return (
    <div className={twJoin("flex flex-1 justify-center items-center h-full", !disabled && "cursor-pointer")}>
      <SupChevronRight className={twJoin("transition-transform duration-200", isExpanded && "rotate-90", disabled && "opacity-16")} />
    </div>
  );
}
